import {combineReducers} from 'redux';
import _, {cloneDeep} from 'lodash';
import * as ActionType from '../../constants/actionType';
import {SerialDilutionAction, CardStateType} from '../../constants/actionType';
import jsonCopy from '../../lib/jsonCopy';
import {SerialDilutionStep} from '../../constants/dataEnum';

const serialDilutionInitialState = {
  sdRawTasks: {},
  sdRawTasksSummary: {
    taskSampleSource: undefined,
    taskDiluentSource: undefined,
    taskSampleTarget: [],
    taskDiluentTargets: [],
  },
  sdProperty: {
    sampleVolume: 0,
    diluentVolume: 0,
    aliquotVolume: 0,
    step: null,
    reuseTips: true,
    replicateWell: 1,
    stepProperties: [
      // {
      // step: 1,
      // ratio: [0, 0],
      // key: '',
      // stepSampleVolume: 0,
      // stepDiluentVolume: 0,
      // }
    ],
  },
};

const initialState = {
  cards: {
    // 0: {
    //   ID: 0,
    //   groupID: null
    //   type: 'Serial Dilution',
    //   name: 'Serial Dilution 1',
    //   isSelected: true,
    //   tasks: [0, 1],
    //   invalidTypes: [],
    //   isInsertTask: false,
    //   isIgnored: false,
    //   prevState: {
    //     task: {},
    //     swab: {taskId: 0, swabTaskId: 1}
    //     action: '',
    //   },
    //   nextState: {
    //     task: {},
    //     swab: {taskId: 0, swabTaskId: 1}
    //     action: '',
    //   },
    // },
  },
  tasks: {
    // 0: {
    //   ID: 0,
    //   isSelected: false,
    //   number: 1,
    //   type: 'Aspirate',
    //   labwareID: 100,
    //   rowtipCount: 8,
    //   columnTipCount: 0,
    //   row: 'A',
    //   column: 1,
    //   volume: 0.5,
    //   delayTime: 5,
    //   isIgnored: false,
    //   tipPosition: 1,
    //   enableMixing: true,
    //   mixingCycle: 0,
    //   mixingVolume: 0,
    //   mixingPosition: 1,
    //   speed: 3,
    //   retractSpeed: 20,
    //   mixingSpeed: 3,
    //   precisionDispense: false,
    //   dispenseAtWellSide: false,
    //   tipTouchOff: false,
    //   tipTouchOffDelay: 0,
    //   serialDilutionType: 'Dilution'
    // },
    // 1: {
    //   ID: 1,
    //   isSelected: false,
    //   number: 2,
    //   type: 'Aspirate',
    //   location: 3,
    //   rowTipCount: 8,
    //   columnTipCount: 0,
    //   row: 'A',
    //   column: 1,
    //   volume: 0.5,
    //   delay: 5,
    //   isIgnored: false,
    //   tipPosition: 1,
    //   mixingCycle: 0,
    //   mixingVolume: 0,
    //   mixingPosition: 1,
    //   speed: 3,
    //   retractSpeed: 20,
    //   mixingSpeed: 3,
    //   precisionDispense: false,
    //   dispenseAtWellSide: false,
    //   tipTouchOff: false,
    //   tipTouchOffDelay: 0,
    // },
  },
  groups: {},
};

function cardsReducer(state = initialState.cards, action = '') {
  switch (action.type) {
    case ActionType.ADD_CARD:
      return {
        ...state,
        [action.cardId]: {
          ID: action.cardId,
          name: action.cardName,
          type: action.cardType,
          isSelected: true,
          isExpanded: true,
          invalidTypes: [],
          isIgnored: false,
          isInsertTask: false,
          reuseTips: action.reuseTips ?? true,
          tasks: [],
          groupID: null,
        },
      };
    case ActionType.ADD_CARD_TASK:
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          ID: action.cardId,
          name: action.cardName,
          type: action.cardType,
          isSelected: true,
          isExpanded: true,
          invalidTypes: state[action.cardId]?.invalidTypes || [],
          isIgnored: false,
          isInsertTask: action.isInsertTask,
          groupID: action.groupId ?? state[action.cardId]?.groupID ?? null,
          tasks: Array.from(
            new Set(
              state[action.cardId] ? [...new Set([...state[action.cardId].tasks, action.taskId])] : [action.taskId],
            ),
          ),
        },
      };
    case ActionType.BATCH_ADD_CARD_TASK: {
      const tasks = action.tasks.map((task) => task.ID);

      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          ID: action.cardId,
          name: action.cardName,
          type: action.cardType,
          isSelected: state[action.cardId]?.isSelected ?? true,
          isExpanded: state[action.cardId]?.isExpanded ?? true,
          invalidTypes: state[action.cardId]?.invalidTypes || [],
          groupID: state[action.cardId]?.groupID ?? null,
          tasks: Array.from(
            // eslint-disable-next-line no-unsafe-optional-chaining
            new Set(state[action.cardId] ? [...new Set([...state[action.cardId]?.tasks, ...tasks])] : [...tasks]),
          ),
        },
      };
    }
    case ActionType.INSERT_CARD_TASK: {
      const cloneTask = state[action.cardId].tasks;
      cloneTask.splice(action.number + 1, 0, action.taskId);
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          ID: action.cardId,
          name: action.cardName,
          type: action.cardType,
          isSelected: true,
          isExpanded: true,
          invalidTypes: state[action.cardId]?.invalidTypes || [],
          isIgnored: state[action.cardId].isIgnored,
          tasks: cloneTask,
        },
      };
    }
    case ActionType.SET_IS_INSERT_CARD:
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          isInsertTask: action.isInsertTask,
        },
      };
    case ActionType.REMOVE_CARD: {
      const {[action.cardId]: removedCard, ...newState} = state;
      return newState;
    }
    case ActionType.REMOVE_CARDS:
      return _.omit(state, action.cardIds);
    case ActionType.REMOVE_CARD_TASK: {
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          tasks: state[action.cardId].tasks.filter((taskId) => taskId !== action.taskId),
        },
      };
    }
    case ActionType.REMOVE_CARD_TASKS: {
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          tasks: state[action.cardId].tasks.filter((taskId) => !action.taskIds.includes(taskId)),
        },
      };
    }
    case ActionType.REMOVE_ALL_CARD_TASKS: {
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          tasks: [],
        },
      };
    }
    case ActionType.SET_CARD_NAME: {
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          name: action.name,
        },
      };
    }
    case ActionType.SWAP_CARD_POSITION: {
      const {cardId, swapCardId} = action;
      const newState = jsonCopy(state);
      return {...newState, [cardId]: state[swapCardId], [swapCardId]: state[cardId]};
    }
    case ActionType.SWAP_TASK_ITEM_POSITION: {
      const {taskId, swapTaskId, cardId} = action;
      const card = jsonCopy(state[cardId]);
      const newTasks = card.tasks;
      const indexTaskId = newTasks.findIndex((id) => id === taskId);
      const indexSwapTaskId = newTasks.findIndex((id) => id === swapTaskId);
      [newTasks[indexTaskId], newTasks[indexSwapTaskId]] = [newTasks[indexSwapTaskId], newTasks[indexTaskId]];

      return {
        ...state,
        [action.cardId]: {...card, tasks: newTasks},
      };
    }
    case ActionType.SET_CARD_IS_SELECTED: {
      const isList = Array.isArray(action.cardId);
      // eslint-disable-next-line no-nested-ternary
      const cardIds = isList ? action.cardId : [action.cardId];

      // select card without unselect other
      if (!action.unselectOther) {
        const newState = {...state};
        cardIds.forEach((c) => {
          if (newState[c]) newState[c] = {...state[c], isSelected: action.selectStatus};
        });
        return newState;
      }

      // select card and unselect other
      const newState = {};
      const cardKeys = Object.keys(state);
      for (let index = 0; index < cardKeys.length; index += 1) {
        const key = parseInt(cardKeys[index], 10);
        if (cardIds.includes(key)) {
          newState[key] = {...state[key], isSelected: action.selectStatus};
        } else {
          newState[key] = {...state[key], isSelected: false};
        }
      }
      return newState;
    }
    case ActionType.SET_CARD_IS_EXPANDED: {
      const isList = Array.isArray(action.cardId);
      // eslint-disable-next-line no-nested-ternary
      const cardIds = isList
        ? action.cardId
        : action.cardId !== null && action.cardId !== undefined
          ? [action.cardId.toString()]
          : [];

      const newState = {};
      const cardKeys = Object.keys(state);
      for (let index = 0; index < cardKeys.length; index += 1) {
        const key = cardKeys[index];
        // eslint-disable-next-line eqeqeq
        if (cardIds.includes(key)) {
          newState[key] = {...state[key], isExpanded: action.isExpanded};
        } else {
          newState[key] = {...state[key], isExpanded: false};
        }
      }
      return newState;
    }
    case ActionType.SET_ALL_CARD_IS_SELECTED: {
      const newState = {};
      const cardKeys = Object.keys(state);
      for (let index = 0; index < cardKeys.length; index += 1) {
        const key = cardKeys[index];
        newState[key] = {...state[key], isSelected: action.isSelected, isExpanded: action.isSelected};
      }
      return newState;
    }
    case ActionType.SAVE_NORMALIZATION_STATE_TO_CARD:
      return {
        ...state,
        [action.cardId]: {...state[action.cardId], normalizationState: action.normalizationState},
      };
    case ActionType.ADD_CARD_INVALID_TYPE:
      return {
        ...state,
        [action.cardId]: {...state[action.cardId], invalidTypes: action.invalidType},
      };
    case ActionType.REMOVE_CARD_INVALID_TYPE:
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          invalidTypes: [],
        },
      };
    case ActionType.SET_IGNORE_CARD:
      return {
        ...state,
        [action.cardId]: {...state[action.cardId], isIgnored: action.isIgnored},
      };
    case ActionType.RESTORE_CARDSTATE:
      return action.state;
    case ActionType.RESTORE_CARDSTATE_BY_ID:
      return {
        ...state,
        [action.card.ID]: action.card,
      };
    case ActionType.BATCH_RESTORE_CARDSTATE_BY_ID: {
      let newState = {...state};
      action.cards.forEach((card) => {
        newState = {
          ...newState,
          [card.ID]: card,
        };
      });
      return newState;
    }
    case ActionType.RESET_CARDSTATE: {
      return initialState.cards;
    }
    case ActionType.CHANGE_BULK_CARD_TASK: {
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          tasks: action.tasks,
        },
      };
    }
    case ActionType.ADD_CARD_BY_OBJECT: {
      return {
        ...state,
        [action.cardId]: action.cardObject,
      };
    }

    // #region serial dilution

    case ActionType.ADD_SD_CARD:
      return {
        ...state,
        [action.cardId]: {
          ID: action.cardId,
          name: action.cardName,
          type: action.cardType,
          isSelected: true,
          isExpanded: true,
          tasks: [],
          invalidTypes: [],
          groupID: state[action.cardId]?.groupID ?? null,
          ...serialDilutionInitialState,
        },
      };
    case ActionType.ADD_SD_RAW_TASK:
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          sdRawTasks: {
            ...state[action.cardId].sdRawTasks,
            ...action.tasks,
          },
        },
      };
    case ActionType.ADD_SD_RAW_TASKS_DILUENT_TARGET:
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          sdRawTasks: {
            ...state[action.cardId].sdRawTasks,
            ...action.tasks,
          },
          sdRawTasksSummary: {
            ...state[action.cardId].sdRawTasksSummary,
            taskDiluentTargets: !state[action.cardId].sdRawTasksSummary.taskDiluentTargets
              ? Object.keys(action.tasks).map((e) => parseInt(e, 10))
              : [
                  ...state[action.cardId].sdRawTasksSummary.taskDiluentTargets,
                  ...Object.keys(action.tasks).map((e) => parseInt(e, 10)),
                ],
          },
        },
      };
    case ActionType.REMOVE_SD_RAW_TASK:
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          sdRawTasks: _.omit(state[action.cardId].sdRawTasks, action.taskId),
        },
      };
    case ActionType.REMOVE_SD_DILUENT_TARGET_RAW_TASK: {
      const taskIds = Array.isArray(action.taskId) ? action.taskId : [action.taskId];
      const filteredSdRawTasks = _.omit(state[action.cardId].sdRawTasks, taskIds);
      let step = 0;
      const sortedSdRawTasks = Object.values(filteredSdRawTasks).reduce((acc, task, idx) => {
        let newTask = task;
        if (task.number === SerialDilutionStep.SET_DILUENT_TARGET) {
          const prevTask = Object.values(filteredSdRawTasks)[idx - 1];
          if (prevTask?.step !== task.step) {
            step += 1;
          }
          newTask = {...task, step};
        }

        acc[newTask.ID] = newTask;

        return acc;
      }, {});

      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          sdRawTasks: sortedSdRawTasks,
          sdRawTasksSummary: {
            ...state[action.cardId].sdRawTasksSummary,
            taskDiluentTargets: state[action.cardId].sdRawTasksSummary.taskDiluentTargets.filter(
              (e) => !taskIds.includes(e),
            ),
          },
          sdProperty: {
            ...state[action.cardId].sdProperty,
            step,
          },
        },
      };
    }
    case ActionType.SET_IGNORE_SD_RAW_TASK:
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          sdRawTasks: {
            ...state[action.cardId].sdRawTasks,
            [action.taskId]: {
              ...state[action.cardId].sdRawTasks[action.taskId],
              isIgnored: action.isIgnored,
            },
          },
        },
      };
    case ActionType.RESTORE_CARD_SDRAWTASKSTATE_BY_ID:
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          sdRawTasks: {
            ...state[action.cardId].sdRawTasks,
            [action.task.ID]: action.task,
          },
        },
      };
    case ActionType.RESTORE_CARD_SDRAWTASKSTATE:
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          sdRawTasks: action.sdRawTasks,
        },
      };
    case ActionType.SET_SD_RAW_TASK_SUMMARY_SAMPLE_SOURCE:
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          sdRawTasksSummary: {...state[action.cardId].sdRawTasksSummary, taskSampleSource: action.task},
        },
      };
    case ActionType.SET_SD_RAW_TASK_SUMMARY_SAMPLE_TARGET:
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          sdRawTasksSummary: {...state[action.cardId].sdRawTasksSummary, taskSampleTarget: action.tasks},
        },
      };
    case ActionType.SET_SD_RAW_TASK_SUMMARY_DILUENT_SOURCE:
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          sdRawTasksSummary: {...state[action.cardId].sdRawTasksSummary, taskDiluentSource: action.task},
        },
      };
    case ActionType.SET_SD_RAW_TASK_SUMMARY_DILUENT_TARGETS:
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          sdRawTasksSummary: {...state[action.cardId].sdRawTasksSummary, taskDiluentTargets: action.tasks},
        },
      };
    case SerialDilutionAction.SET_SD_RAW_TASKS_SUMMARY:
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          sdRawTasksSummary: action.rawSummary,
        },
      };
    case ActionType.SET_CARD_SD_PROPERTY:
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          sdProperty: action.sdProperty,
        },
      };
    case ActionType.SET_SD_PROPERTY_OBJECT: {
      const {cardId, newValue} = action;

      return {
        ...state,
        [cardId]: {
          ...state[cardId],
          sdProperty: {
            ...state[cardId].sdProperty,
            ...newValue,
          },
        },
      };
    }
    case ActionType.REMOVE_SD_PROPERTY_OBJECT: {
      const {cardId, sdPropertyObjectKey} = action;

      const {[sdPropertyObjectKey]: removedSdProp, ...restOfSdProp} = state[cardId].sdProperty || {};

      return {
        ...state,
        [cardId]: {
          ...state[cardId],
          sdProperty: restOfSdProp,
        },
      };
    }
    case ActionType.SET_SD_STEP_PROPERTIES_OBJECT: {
      const {cardId, stepNumber, newValue} = action;
      const stepNumbers = _.isArray(stepNumber) ? stepNumber : [stepNumber];
      const newValues = _.isArray(newValue) ? newValue : [newValue];

      let stepProperties = [...(state[cardId]?.sdProperty?.stepProperties ?? [])];

      stepNumbers.forEach((stepNum, idx) => {
        stepProperties[stepNum - 1] = {
          ...stepProperties[stepNum - 1],
          ...(newValues[idx] || newValue),
          step: stepNum,
        };
      });

      stepProperties = Array.from(stepProperties, (el, idx) => (!el ? {step: idx + 1} : el));

      return {
        ...state,
        [cardId]: {
          ...state[cardId],
          sdProperty: {
            ...state[cardId].sdProperty,
            stepProperties,
          },
        },
      };
    }
    case ActionType.SET_SD_RAW_TASK_IS_SELECTED: {
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          sdRawTasks: {
            ...state[action.cardId].sdRawTasks,
            [action.taskId]: {
              ...state[action.cardId].sdRawTasks[action.taskId],
              isSelected: action.isSelected,
              isExpanded: action.isExpanded,
            },
          },
        },
      };
    }

    case ActionType.SET_CARD_REUSE_TIP: {
      return {
        ...state,
        [action.cardId]: {...state[action.cardId], reuseTips: action.data},
      };
    }
    case ActionType.SET_SD_REPLICATE_WELL: {
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          sdProperty: {
            ...state[action.cardId].sdProperty,
            replicateWell: action.replicateWell,
          },
        },
      };
    }

    // #endregion serial dilution

    // #region card grouping

    case ActionType.ADD_CARD_GROUP: {
      let newState = state;
      action.cardIDs.forEach((cardId) => {
        newState = {
          ...newState,
          [cardId]: {...newState[cardId], groupID: action.groupID},
        };
      });
      return newState;
    }

    // #endregion card grouping
    default:
      return state;
  }
}

function tasksReducer(state = initialState.tasks, action = '') {
  switch (action.type) {
    case ActionType.ADD_CARD_TASK:
      return {
        ...state,
        [action.taskId]: action.task,
      };
    case ActionType.BATCH_ADD_CARD_TASK: {
      let newState = {...state};

      action.tasks.forEach((task) => {
        newState = {
          ...newState,
          [task.ID]: task,
        };
      });
      return newState;
    }
    case CardStateType.BATCH_ADD_TASKS: {
      return {...state, ...action.newTasks};
    }
    case ActionType.INSERT_CARD_TASK:
      return {
        ...state,
        [action.taskId]: action.task,
      };
    case ActionType.REMOVE_CARD:
    case ActionType.REMOVE_CARDS: {
      return _.omit(state, action.taskIds);
    }
    case ActionType.REMOVE_CARD_TASK: {
      return _.omit(state, [action.taskId]);
    }
    case ActionType.REMOVE_CARD_TASKS: {
      return _.omit(state, action.taskIds);
    }
    case ActionType.REMOVE_ALL_CARD_TASKS: {
      return _.omit(state, action.taskIds);
    }
    case ActionType.SWAP_TASK_ITEM_POSITION: {
      const {taskId, swapTaskId} = action;
      const newState = jsonCopy(state);
      return {
        ...newState,
        [taskId]: {...state[taskId], number: state[swapTaskId].number},
        [swapTaskId]: {...state[swapTaskId], number: state[taskId].number},
      };
    }
    case ActionType.SET_IGNORE_CARD_TASK:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], isIgnored: action.isIgnored},
      };
    case ActionType.SET_TASK_NUMBER:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], number: action.number},
      };
    case ActionType.SET_TASK_ROW:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], row: action.row},
      };
    case ActionType.SET_TASK_COLUMN:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], column: action.column},
      };
    case ActionType.SET_TASK_ROW_TIP_COUNT:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], rowTipCount: action.rowTipCount},
      };
    case ActionType.SET_TASK_COLUMN_TIP_COUNT:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], columnTipCount: action.columnTipCount},
      };
    case ActionType.SET_TASK_LABWARE:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], labwareID: action.labwareID},
      };
    case ActionType.SET_TASK_LABWARE_INDEX:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], labwareIndex: action.labwareIndex},
      };
    case ActionType.SET_TASK_TIP_POSITION:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], tipPosition: action.tipPosition},
      };
    case ActionType.SET_TASK_MIXING_POSITION:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], mixingPosition: action.mixingPosition},
      };
    case ActionType.SET_TASK_MIXING_POSITION_ASPIRATE:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], mixingPositionAspirate: action.mixingPositionAspirate},
      };
    case ActionType.SET_TASK_MIXING_POSITION_DISPENSE:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], mixingPositionDispense: action.mixingPositionDispense},
      };
    case ActionType.SET_TASK_ENABLE_MIXING:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], enableMixing: action.enableMixing},
      };
    case ActionType.SET_TASK_MIXING_CYCLE:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], mixingCycle: action.mixingCycle},
      };
    case ActionType.SET_TASK_MIXING_VOLUME:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], mixingVolume: action.mixingVolume},
      };
    case ActionType.SET_TASK_SPEED:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], speed: action.speed},
      };
    case ActionType.SET_TASK_RETRACT_SPEED:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], retractSpeed: action.retractSpeed},
      };
    case ActionType.SET_TASK_MIXING_SPEED:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], mixingSpeed: action.mixingSpeed},
      };
    case ActionType.SET_TASK_PRECISION_DISPENSE:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], precisionDispense: action.precisionDispense},
      };
    case ActionType.SET_TASK_VOLUME:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], volume: action.volume, type: action.taskType},
      };
    case ActionType.SET_TASK_TIP_TOUCH_OFF:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], tipTouchOff: action.tipTouchOff},
      };
    case ActionType.SET_TASK_TIP_TOUCH_OFF_DELAY:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], tipTouchOffDelay: action.tipTouchOffDelay},
      };
    case ActionType.SET_TASK_TIP_TOUCH_OFF_HEIGHT:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], tipTouchOffHeight: action.tipTouchOffHeight},
      };
    case ActionType.SET_TASK_TIP_TOUCH_OFF_DIRECTION_X:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], tipTouchOffDirectionX: action.tipTouchOffDirectionX},
      };
    case ActionType.SET_TASK_TIP_TOUCH_OFF_DIRECTION_Y:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], tipTouchOffDirectionY: action.tipTouchOffDirectionY},
      };
    case ActionType.SET_TASK_DISPENSE_AT_WELL_SIDE:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], dispenseAtWellSide: action.dispenseAtWellSide},
      };
    case ActionType.SET_TIP_X_POSITION_OFFSET:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], tipXPositionOffset: action.tipXPositionOffset},
      };
    case ActionType.SET_TIP_Y_POSITION_OFFSET:
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], tipYPositionOffset: action.tipYPositionOffset},
      };
    case ActionType.SET_TASK_IS_SELECTED: {
      if (action.taskId in state) {
        return {
          ...state,
          [action.taskId]: {...state[action.taskId], isSelected: action.isSelected},
        };
      }
      return {...state};
    }
    case ActionType.BATCH_SET_TASKS_LOCATION: {
      let tasksCopy = cloneDeep(state);
      action.taskIds.forEach((taskId) => {
        if (taskId in tasksCopy) {
          tasksCopy = {
            ...tasksCopy,
            [taskId]: {...state[taskId], labwareID: action.labwareID},
          };
        }
      });
      return {...tasksCopy};
    }
    case ActionType.SET_ALL_TASK_IS_SELECTED: {
      const newState = {};
      const taskKeys = Object.keys(state);
      for (let index = 0; index < taskKeys.length; index += 1) {
        const key = taskKeys[index];
        newState[key] = {...state[key], isSelected: action.isSelected};
      }
      return newState;
    }
    case ActionType.RESTORE_CARDTASKSTATE:
      return action.state;
    case ActionType.RESTORE_CARDTASKSTATE_BY_ID:
      return {
        ...state,
        [action.task.ID]: action.task,
      };
    case ActionType.BATCH_RESTORE_CARDTASKSTATE_BY_ID: {
      let newState = {...state};
      for (let index = 0; index < action.tasks.length; index += 1) {
        const task = action.tasks[index];
        newState = {
          ...newState,
          [task.ID]: task,
        };
      }
      return newState;
    }
    case ActionType.RESET_CARDSTATE:
    case ActionType.RESET_CARDTASKSTATE: {
      return initialState.tasks;
    }

    // #region broadcast

    case ActionType.SET_BROADCAST_VOLUME: {
      const newState = jsonCopy(state);

      action.tasks.forEach((e) => {
        const {id, volume, mixingVolume} = e;

        newState[id].volume = volume;
        newState[id].mixingVolume = mixingVolume;
      });

      return newState;
    }

    // #endregion broadcast

    // #region pooling

    case ActionType.SET_POOLING_VOLUME: {
      const newState = jsonCopy(state);

      action.tasks.forEach((e) => {
        const {id, volume, mixingVolume} = e;

        newState[id].volume = volume;
        newState[id].mixingVolume = mixingVolume;
      });

      return newState;
    }

    // #endregion pooling

    case ActionType.SET_HUMIDITY_LEVEL: {
      return {
        ...state,
        [action.taskId]: {...state[action.taskId], humidityLevel: action.humidityLevel},
      };
    }

    default:
      return state;
  }
}

function groupsReducer(state = initialState.cards, action = '') {
  switch (action.type) {
    case ActionType.ADD_CARD_GROUP:
      return {
        ...state,
        [action.groupID]: action.group,
      };
    case ActionType.REMOVE_CARD_GROUP_CARDS: {
      return {
        ...state,
        [action.groupID]: {
          ...state[action.groupID],
          cards: state[action.groupID].cards.filter((cardId) => !action.cardIds.includes(cardId)),
        },
      };
    }
    case CardStateType.GROUP_ADD_CARD_LIST: {
      return {
        ...state,
        [action.groupID]: {
          ...state[action.groupID],
          cards: [...state[action.groupID].cards, ...action.cardIDs],
        },
      };
    }
    case ActionType.SET_CARD_GROUP_NAME: {
      return {
        ...state,
        [action.groupID]: {
          ...state[action.groupID],
          name: action.name,
        },
      };
    }
    case ActionType.REMOVE_CARD_GROUP: {
      return _.omit(state, action.groupIDs);
    }
    case ActionType.RESET_GROUPSTATE: {
      return initialState.groups;
    }
    case ActionType.RESTORE_GROUPSTATE:
      return action.state;
    case ActionType.SET_GROUP_IS_SELECTED: {
      const isList = Array.isArray(action.groupId);
      if (!action.unselectOther) {
        if (isList) {
          const newState = {...state};
          action.groupId.forEach((c) => {
            if (newState[c]) newState[c] = {...state[c], isSelected: action.selectStatus};
          });
          return newState;
        }
        const newState = {
          ...state,
          [action.groupId]: {...state[action.groupId], isSelected: action.selectStatus},
        };
        return newState;
      }
      const newState = {};
      const groupKeys = Object.keys(state);
      if (isList) {
        for (let index = 0; index < groupKeys.length; index += 1) {
          const key = groupKeys[index];
          // eslint-disable-next-line eqeqeq
          if (action.groupId.includes(key)) {
            newState[key] = {...state[key], isSelected: action.selectStatus};
          } else {
            newState[key] = {...state[key], isSelected: false};
          }
        }
        return newState;
      }

      for (let index = 0; index < groupKeys.length; index += 1) {
        const key = groupKeys[index];
        // eslint-disable-next-line eqeqeq
        if (key == action.groupId) {
          newState[key] = {...state[key], isSelected: action.selectStatus};
        } else {
          newState[key] = {...state[key], isSelected: false};
        }
      }
      return newState;
    }
    case ActionType.SET_GROUP_IS_EXPANDED: {
      if (action.groupID === undefined) {
        const newState = state;

        Object.keys(newState).forEach((key) => {
          newState[key] = {
            ...newState[key],
            isExpanded: false,
          };
        });

        return newState;
      }
      return {
        ...state,
        [action.groupID]: {
          ...state[action.groupID],
          isExpanded: action.isExpanded,
        },
      };
    }
    case ActionType.SET_GROUP_IS_ALL_EXPANDED: {
      const newState = state;

      Object.keys(newState).forEach((key) => {
        newState[key] = {
          ...newState[key],
          isExpanded: true,
        };
      });

      return newState;
    }
    case ActionType.SET_ALL_GROUP_IS_SELECTED: {
      const newState = {};
      const groupKeys = Object.keys(state);
      for (let index = 0; index < groupKeys.length; index += 1) {
        const key = groupKeys[index];
        newState[key] = {...state[key], isSelected: action.isSelected};
      }
      return newState;
    }
    default:
      return state;
  }
}

const cardStateReducer = combineReducers({
  cards: cardsReducer,
  tasks: tasksReducer,
  groups: groupsReducer,
});

export default cardStateReducer;
